var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallBarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F8153B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2532_1710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2532_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 26L14.3334 23.3333L15.2667 22.4L16.3334 23.45V19.3333H14C13.6334 19.3333 13.3195 19.2028 13.0584 18.9417C12.7972 18.6806 12.6667 18.3667 12.6667 18V14H14V18H16.3334C16.7 18 17.0139 18.1306 17.275 18.3917C17.5361 18.6528 17.6667 18.9667 17.6667 19.3333V23.45L18.7167 22.4L19.6667 23.3333L17 26ZM23 26L20.3334 23.3333L21.2667 22.4L22.3334 23.45V19.3333C22.3334 18.9667 22.4639 18.6528 22.725 18.3917C22.9861 18.1306 23.3 18 23.6667 18H26V14H27.3334V18C27.3334 18.3667 27.2028 18.6806 26.9417 18.9417C26.6806 19.2028 26.3667 19.3333 26 19.3333H23.6667V23.4667L24.7167 22.4L25.6667 23.3333L23 26Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBarge);
export default __webpack_public_path__ + "static/media/CallBarge.d42933c9cf8ceadf0e87afc7318e4f52.svg";
export { ForwardRef as ReactComponent };